<template>

    <div id="case_study_detail_wrapper" class="d-block d-lg-flex flex-nowrap px-0 px-sm-5 px-lg-0 min-400-vw">

        <!-- pane 1: text + pic -->
        <div :id="'cs_' + index + '_pane_1'" class="vw-lg-100 d-lg-flex bg-texture p-5 extra-pad">
            <div class="w-responsive w-100 mr-xl-0 d-xl-flex">
                <div class="main-image-wrap">
                    <!-- label -->
                    <div class="d-flex justify-content-end w-75">
                        <h3 :class="{'purple': index == 1}" class="guide-text mb-3">{{ $t(iKey('related_case_studies', i, 'label')) }}<br>{{ i.name }}</h3>
                    </div>

                    <!-- main image & caption -->
                    <div class="texture bg-lazy" v-if="i.texture_image" v-lazy:background-image="i.texture_image.url_resized_large">
                        <figure class="mr-4">
                            <img v-lazy="i.main_image.url_resized_square" class="img-fluid portrait px-5 py-3" :alt="$t(iKey('related_case_studies', i, 'main_image_desc'))">
                            <figcaption class="text-right mr-5">{{ $t(iKey('related_case_studies', i, 'main_image_caption')) }}</figcaption>
                        </figure>
                    </div>
                </div>

                <!-- trait highlighter -->
                <div class="traits-column px-3 d-xl-flex flex-column align-self-center align-self-lg-start" >
                    <span aria-hidden="true" class="giant align-self-end d-none d-xl-inline" v-html="firstLetter(i.name)"></span>
                    <div v-if="index == 0">
                        <p class="guide-text2 mouse-only">{{ $t(iKey('case_study_section','case_study_traits','cta')) }}</p>
                        <p class="guide-text2 touch-only">{{ $t(iKey('case_study_section','case_study_traits','cta_touch')) }}</p>
                        <ul class="highlight-key list-unstyled">
                            <li class="guide-text2" :class="'highlight-' + index" v-for="(t, index) in traitLabels" :key="index">
                                <span class="bullet" :style="{'backgroundColor': '#' + t.highlight_color}"></span>
                                {{ $t(iKey('case_study_section', 'case_study_traits', 'label_' + index ))}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            

            <!-- paragraph 1 -->
            <div class="d-flex justify-content-between paragraph-1 w-100">
                <div class="w-100 pr-xl-4 pt-3 d-flex">
                    <Highlightable class="align-self-center text" :containerId="'cs_' + index + '_p_1'">
                        <div class="px-3" v-html="$t(iKey('related_case_studies', i, 'paragraph_1'))"></div>
                    </Highlightable>
                    <!-- 
                    <div>
                        <img v-if="i.secondary_image" class="align-self-start" :src="i.secondary_image.url_resized" :alt="$t(iKey('related_case_studies', i, 'secondary_image_desc'))">
                    </div>
                    -->
                </div>

            </div>
            
            <!-- next btn desktop -->
            <div class="d-none d-lg-flex">
                <CtaCircleSmall :purple="index == 1" class="align-self-center next" @clicked="$parent.scrollToPane('#cs_' + index + '_pane_2')"></CtaCircleSmall>
            </div>
            
        </div>

        <!-- pane 2: text -->
        <div :id="'cs_' + index + '_pane_2'" class="vw-lg-100 d-lg-flex p-5 dashed bg-texture extra-pad">
            <!-- paragraph 2 -->
            <Highlightable class="align-self-center text w-70 pb-4 pb-lg-0" :containerId="'cs_' + index + '_p_2'">
            <div class="px-3" v-html="$t(iKey('related_case_studies', i, 'paragraph_2'))"></div>
            </Highlightable>

            <!-- pull quote -->
            <div class="my-5 my-lg-0 px-lg-5 w-50">
                <QuoteHeader :bgColor="index == 1 ? '#7575bf': '#ed7530'"></QuoteHeader>
                <blockquote>
                    {{ $t(iKey('related_case_studies', i, 'pull_quote')) }}
                    <footer>{{ $t(iKey('related_case_studies', i, 'pull_quote_attr')) }}</footer>
                </blockquote>
            </div>

            <div class="d-none d-lg-flex">
                <CtaCircleSmall :purple="index == 1" class="align-self-center next" @clicked="$parent.scrollToPane('#cs_' + index + '_pane_3')"></CtaCircleSmall>
            </div>

        </div>

        <!-- pane 3: video -->
        <div :id="'cs_' + index + '_pane_3'" class="position-relative">
            <!--<div v-if="i.poster_image" class="vw-100 vh-100" :style="{backgroundImage: 'url(' + i.poster_image.url_resized_large + ')',  backgroundSize: 'cover'}"></div>-->
            <div class="vw-lg-100 vh-100 position-relative d-flex justify-content-around">
                <div class="align-self-center vid-wrap">
                    <VideoEmbed 
                        ref="vid_embed"
                        :video_descr="$t(iKey('related_case_studies', i, 'video_desc_embed'))"
                        :video_regular="$t(iKey('related_case_studies', i, 'video_embed'))">
                    </VideoEmbed>
                </div>
            </div>
             <div class="d-none d-lg-flex p-1 position-absolute video-next">
                <CtaCircleSmall :purple="index == 1" class="align-self-center next" @clicked="$parent.scrollToPane('#cs_' + index + '_pane_4')"></CtaCircleSmall>
            </div>
        </div>

        <!-- pane 4: transition text -->
        <div :id="'cs_' + index + '_pane_4'" class="vw-lg-100 my-5 my-lg-0 d-flex flex-column justify-content-center align-items-center bg-texture position-relative" >
            <div class="w-75 text-center my-5 my-lg-0">
                <div class="justify-content-center d-flex">
                    
                    <div class="d-flex flex-column w-100">
                        <h3 class="colorized px-5 h1" v-html="colorize($t(iKey('related_case_studies', i, 'transition_next')))"></h3>
                    </div>
                    
                    <div class="d-none d-lg-flex flex-column justify-content-center position-absolute next-arrow-wrap pr-4 vh-100">
                        <CtaCircleSmall 
                            v-if="index == 0" 
                            :purple="true" 
                            class="align-self-center next" 
                            @clicked="$parent.scrollToPane('#cs_1_pane_1')"></CtaCircleSmall>
                    </div>
                </div>
               
            </div>
        </div>
    </div>
    
</template>

<script>
import { i18nKey } from '@/services/i18n/i18n.js'
import ScrollMagic from 'scrollmagic';
import Highlightable from '@/components/ui/Highlightable'
import CtaCircleSmall from '@/components/ui/CtaCircleSmall'

import QuoteHeader from '@/components/ui/QuoteHeader'
import VideoEmbed from '@/components/ui/VideoEmbed'


export default {
  name: 'CaseStudies',
  data: () => {
      return {
          panes: [0,1,2,3],
          descriptive: false,
          lastPane: false
      }
  },
  props: [
    'index',
    'i',
    'items',
    'case_study_section'
  ],
  components: {
      Highlightable,
      CtaCircleSmall,
      QuoteHeader,
      VideoEmbed
  },
  methods: {
    iKey(section, obj, field){
      return i18nKey(section, obj, field)
    },
    firstLetter(name){
        if(name){
            return name.charAt(0);
        } else {
            return ""
        } 
    },
    colorize(string){
        if(!string) return ""
        var n = []
        var newString = string
        this.$props.items.forEach(obj => {
            n.push(obj.name.split(" ")[0])
        })
        newString = string.replace(n[0], '<span>' + n[0] + "</span>")
        return newString.replace(n[1], '<span class="purple">' + n[1] + "</span>")
    }
  },
  computed: {
      traitLabels(){
          var labels;
          this.case_study_section.forEach(obj => {
              if(obj.type == 'case_study_traits'){
                  labels = obj.value.labels
              }
          })

        return labels
      }
  },
  mounted() {
        // Horizontal ScrollMagic controller instance for pagination, video playback stopping on horizontal scroll
        let controller_h = new ScrollMagic.Controller({vertical: false});        
        if(this.$props.index == 0){ // for the intro scroll position
            let trigger = '#intro_pane_1';
            let toggle = '#side_scroll_intro_pane_1';
            
            new ScrollMagic.Scene({
                triggerElement: trigger,
                duration: '100%'
            })
            .setClassToggle(toggle, 'active')
            .addTo(controller_h)
        }
       
        this.$data.panes.forEach(i => {
            let trigger = '#cs_' + this.$props.index  + '_pane_' + (i + 1);
            let toggle = '#side_scroll_cs_' + this.$props.index + '_pane_' + (i + 1)
            
            new ScrollMagic.Scene({
                triggerElement: trigger,
                duration: '100%'
            })
            .setClassToggle(toggle, 'active')
            .on('leave', () => {
                this.$refs.vid_embed.stop()
                if(i + 1 == this.$data.panes.length & this.index == 1){
                    this.$emit('lastPane', false);
                }
            })
            .on('enter', () => {
                if(i + 1 == this.$data.panes.length & this.index == 1){
                    this.$emit('lastPane', true);
                }
            })
            .addTo(controller_h)
        })

        // Vertical Scroll Magic scene for stopping video on vertical scroll
        const scene = this.$scrollmagic.scene({
            triggerElement: '#cs_' + this.index + '_pane_3',
            //triggerHook: 0,
            duration: '100%'
        })
        this.$scrollmagic.addScene(
        scene
            .on('leave', () => {
                this.$refs.vid_embed.stop()
            })
            //.addIndicators()
        )  
  }
}
</script>

<style scoped>
.vw-100 {
    min-width: 100vw;
}

.min-400-vw {
    min-width: none;
}
@media(min-width: 992px){
    .min-400-vw {
        min-width: 400vw;
    }
}

.vw-lg-100 {
    width: auto;
}
@media(min-width: 992px){
    .vw-lg-100 {
        min-width: 100vw;
    }   
}

@media (pointer: coarse) {
    .touch-only { display: block }
    .mouse-only { display: none }
}

@media (pointer: fine) {
    .touch-only { display: none }
    .mouse-only { display: block }
}

.giant {
    font-size: 100px;
    color: #382e2b;
}
@media (min-width: 992px) { 
    .giant {
        font-size: 250px;
    }
}
.guide-text {
    color: #ed7530;
    font-size: 100%;
}
@media (max-width: 992px) { 
    .guide-text {
        font-size: 120%;
    }
}
.guide-text.purple {
    color: #7575bf;
}

.bg-texture {
        background: none;
    }
@media (min-width: 992px) { 
    .bg-texture {
        background-image: url(../../assets/images/photocopy-bg.jpg);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: right bottom;
    } 
}

.vw-100 {
    width: auto !important;
}
@media (min-width: 992px) { 
    .vw-100 {
        width: 100vw !important;
    }   
}
.vh-100 {
    height: auto !important;
}
@media (min-width: 992px) { 
    .vh-100 {
        height: 100vh !important;
    }
}
.w-50 {
    width: auto !important;
}
@media (min-width: 576px) { 
    .w-50 {
        width: 50% !important;
    }
}
@media(min-width: 992px){
    .extra-pad {
        padding-left: 6em !important;
        padding-right: 6em !important;
    }
}

@media(min-width: 992px){
    .paragraph-1.w-100 {
        width: 100% !important;
    }
}
@media(min-width: 1367px){
    .paragraph-1.w-100 {
        width: 75% !important;
    }
}

.main-image-wrap {
    transform: rotate(-3deg);
    margin-left: -40px;
    
}
@media (min-width: 992px) { 
    .main-image-wrap {
        width: 100%;
        margin-left: -60px;
    }
}

.main-image-wrap figcaption {
    transform: rotate(3deg);
    padding-right: 40px;
    margin-top: 10px;
}

.main-image-wrap .texture {
    background-size: contain;
    background-repeat: no-repeat;
    background-position-x: 50px;
}
.traits-column {
    width: auto;
}
@media (min-width: 768px) { 
    .traits-column {
        width: 350px;
    }
}
.text {
    min-height: auto;
}
@media (min-width: 768px) { 
    .text {
       width: 70%;
    }
}
@media (min-width: 992px) { 
    .text {
        min-height: 70vh;
        width: 100%;
    }
}

.vid-wrap {
    width: 100%;
}
@media (min-width: 992px) { 
    .vid-wrap {
        width: 70%;
    }
}
.video-next {
    right: 30px;
    top: calc(50% - 25px);
}
.quote-underline {
    width: 205px;
    height: 50px;
    background-color:#ed7530;
    background-image: url(../../assets/images/quote-block-texture.png);
    background-repeat: no-repeat;
    background-blend-mode: multiply;
    background-position: 200%, 0;
    margin: 25px 0 50px 0;
}
.quote-underline.purple {
    background-color:#7575bf;
    background-blend-mode:multiply;
}
.dashed {
    /* border-left: 1px dashed #bbbbbb; */
}
.highlight-key li {
    list-style-type: none;
    position: relative;
    left: 30px;
    margin-bottom: 15px;
}
.highlight-key .bullet {
    padding-right: 0.05em;
    display: inline-block;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    vertical-align: middle;
    font-family: Arial, Helvetica, sans-serif;
    position: absolute;
    left: -30px;
}
.next-arrow-wrap {
    top: 0;
    right: 0;
}

</style>

<style>
h3.colorized span {
    color: #ed7530;
}
h3.colorized span.purple {
    color: #7575bf;
}

</style>